/* template */
<template minapp="mpx" xlang="wxml"><div class="train-rules"><div class="head"><div class="title">购买须知</div><div class="customer-service"><mpx-image :src="(arrow)" class="icon"/><mpx-view @tap="toCustomerService" class="more-text">联系客服</mpx-view></div></div><div class="con"><mpx-view v-for="(item, index) in (arrList)" @tap="jumpFn(item.url)" class="item">{{ item.title }}</mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m58f4c7b2"}'>
@import '~@/mixins/stylus/color.styl'

.train-rules
  background #FFFFFF
  border-radius 8px
  padding 14px
  margin-bottom 10px
.head
  display flex
  justify-content space-between
  .title
    font-family PingFangSC-Medium
    font-size 16px
    font-weight normal
    line-height 16px
    letter-spacing 0px
    color #333333
  .customer-service
    display flex
    align-items center
    .icon
      width 14px
      height 14px
      margin-right 4px
    .more-text
      font-family PingFangSC-Regular
      font-size 14px
      line-height 14px
      letter-spacing 0px
      color #999999
.con
  margin-top 6px
  .item
    display inline-block
    border-radius 6px
    box-sizing border-box
    position relative
    padding 8px
    font-family PingFangSC-Regular
    font-size 13px
    line-height 13px
    color #666666
    margin-right 5px
    margin-top 5px
    &::after
      position absolute
      content: ""
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #ccc
      transform-origin 0 0
      transform scale(0.5)
      border-radius 12px
      top 0
      left 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m58f4c7b2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex58f4c7b2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex58f4c7b2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m58f4c7b2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index58f4c7b2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
